/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react';
import { Tooltip as BootstrapTooltop, Modal as BootstrapModal } from 'bootstrap';

interface ModalProps {
  modalText?: string
  modalTitle: string;
  id?: string;
  onClose: () => void;
  showModal?: boolean;
}
function Modal(props: ModalProps) {
  const {
    modalTitle, id, modalText, onClose, showModal,
  } = props;
  const modal = useRef(null);

  useEffect(() => {
    if (showModal && modal.current) {
      const bootstrapModal = new BootstrapModal(modal.current);
      bootstrapModal.show();
    }
  }, [showModal, modal]);
  return (
    <div ref={modal} className="modal" onClick={onClose}>
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            {modalTitle && (
            <h5 className="modal-title">{modalTitle}</h5>
            )}
            <button type="button" onClick={onClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body" dangerouslySetInnerHTML={{ __html: modalText || '' }} />
        </div>
      </div>
    </div>
  );
}

Modal.defaultProps = {
  modalText: null,
  showModal: false,
  id: '',
};

export default Modal;
